export var hostUrl = "https://salarysurvey.codex.co.il";
export var apiUrl = hostUrl + "/webapi/api";
// export const hostUrl = "http://localhost:44365";
// export const apiUrl = `${hostUrl}/api`;



//////////////////
// WEBPACK FOOTER
// ./src/utils/settings.ts
// module id = 713
// module chunks = 0